import { render } from "./newsSlider.vue?vue&type=template&id=fd3b03b8&scoped=true"
import script from "./newsSlider.vue?vue&type=script&lang=js"
export * from "./newsSlider.vue?vue&type=script&lang=js"

import "./newsSlider.vue?vue&type=style&index=0&id=fd3b03b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3b03b8"]])

export default __exports__